import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineXIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M8 19a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3 1 1 0 0 0 0-2 5 5 0 0 0-5 5v8a4.9997 4.9997 0 0 0 5 5 1.0002 1.0002 0 0 0 .7071-1.7071A1.0002 1.0002 0 0 0 8 19Zm7.71-3.29a.9997.9997 0 0 0 0-1.42L13.41 12l2.3-2.29a1.0041 1.0041 0 1 0-1.42-1.42L12 10.59l-2.29-2.3a1.0041 1.0041 0 0 0-1.42 1.42l2.3 2.29-2.3 2.29a1.001 1.001 0 0 0-.2958.71 1.0003 1.0003 0 0 0 .2958.71 1.001 1.001 0 0 0 .71.2958.9994.9994 0 0 0 .71-.2958l2.29-2.3 2.29 2.3a.9997.9997 0 0 0 1.42 0ZM16 3a1 1 0 1 0 0 2 3 3 0 0 1 3 3v8a3 3 0 0 1-3 3 1.0001 1.0001 0 0 0 0 2 4.9997 4.9997 0 0 0 5-5V8a5 5 0 0 0-5-5Z"/>
  </SvgIcon>
}

export default LineXIcon
